
import plugin from '../../lib/plugin';
import * as productSlider from  './product-slider';
const ELEMENT_SELECTOR = '[data-swiper]';
const ATTR = 'data-swiper';
const THUMBNAILS_ATTR = '[data-swiper-thumbnails="{0}"]';
const SLIDE_SELECTOR = '.swiper-slider';
const TRANSITION_START_CLASS = 'swiper-slider--transition';

class SwiperPlugin {
	constructor(element, options) {
		this.element = element;
        this.options = options;
        this.code = $(element).attr(ATTR);
        this.thumbnails = $(THUMBNAILS_ATTR.replace('{0}',this.code));
        this.hasThumbnails = typeof(this.thumbnails) !== 'undefined' && this.thumbnails.length > 0;
        this.iframeSlides = $(element).find('.swiper-slide iframe');

        var mod = this;
        System.import(
            /* webpackChunkName: "core/vendor/swiper/swiper-bundle.min" */
            '@core/vendor/swiper/swiper-bundle.min'
        )
        .then((swiper) => {
            mod.swiper = swiper;
            window.swiper = swiper;
            mod.init();
            productSlider.exec();
        });
    }

    // setIframeHeight() {
    //     for(var i=0;i<this.iframeSlides.length;i++) {
    //         var frame = this.iframeSlides[i];
    //         var width = $(frame).width();
    //         $(frame).css('height', width);
    //     }
    // }

    setTransitionStart() {
        $(this.element).addClass(TRANSITION_START_CLASS);
    }

    setTransitionEnd() {
        $(this.element).removeClass(TRANSITION_START_CLASS);
    }

	init() {
        var mod = this;
        // $(window).on('resize',function() {
        //     mod.setIframeHeight();
        // });
        if (this.hasThumbnails) {
            var totalThumbs = this.thumbnails.find(SLIDE_SELECTOR);
            var slidesPerView = totalThumbs < 7 ? totalThumbs : 7;
            var galleryThumbs = new this.swiper('.gallery-thumbs', {
                slidesPerView: slidesPerView,
                spaceBetween: 10,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
            });

            this.thumbnailsSlider = galleryThumbs;

            this.slider = new this.swiper(this.element, {
                slidesPerView: 1,
                spaceBetween: 0,
                loop:true,
                thumbs: {
                    swiper: galleryThumbs
                },
                on: {
                    transitionEnd: function() {
                        mod.setTransitionEnd();
                    },
                    transitionStart: function() {
                        mod.setTransitionStart();
                    },
                },
                navigation: {
                    nextEl: '.swiper-button-next-product',
                    prevEl: '.swiper-button-prev-product'
                }
            });

        }
        else {
            this.slider = new this.swiper(this.element, {
                slidesPerView: 1,
                spaceBetween: 0,
                loop:true,
                on: {
                    transitionEnd: function() {
                        mod.setTransitionEnd();
                    },
                    transitionStart: function() {
                        mod.setTransitionStart();
                    },
                },
                navigation: {
                    nextEl: '.swiper-button-next-product',
                    prevEl: '.swiper-button-prev-product'
                }
            });
        }

        $(window).on('reinit-swiper', function() {
            mod.slider.update();
            if (mod.hasThumbnails) {
                mod.thumbnailsSlider.update();
            }
        });

        $(window).trigger('resize');
	}

}

SwiperPlugin.DEFAULTS = {
};


plugin('swiperPlugin', SwiperPlugin);

export function exec () {
    $(document).ready(() => {
        $(ELEMENT_SELECTOR).swiperPlugin();
        if ($(ELEMENT_SELECTOR).length ==0) {
            productSlider.exec();
        }
    });
}



// WEBPACK FOOTER //
// ./client/src/core/components/swiper/swiper.js